export default () => (input) => {
    const scrubbedInput = (input === undefined || input === null) ? '' : input;
    return scrubbedInput.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
	   return ch.toUpperCase();
    });
}
